<template>
  <div class="subscription-expired-page">
    <div class="subscription-card">
      <div class="subscription-icon">
        <!-- Bootstrap Icons -->
        <i class="bi bi-exclamation-triangle-fill"></i>
      </div>
      <h1 class="title">Subscription Expired</h1>
      <p class="message">
        Your subscription has expired. To continue using our services, please renew your
        subscription.
      </p>
      <div class="details">
        <p>
          <strong>What happens now?</strong>
        </p>
        <ul>
          <li>You will no longer have access to premium features.</li>
          <li>Your data will be stored securely for the next 30 days.</li>
          <li>After 30 days, your data may be permanently deleted.</li>
        </ul>
        <p>
          If you have any questions or need assistance, please contact service provider.
        </p>
      </div>
      <button class="btn btn-renew" @click="renewSubscription">Go Back</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubscriptionExpired",
  methods: {
    renewSubscription() {
      // Add logic to redirect to the renewal page
      this.$router.push({ path: "/login" });
    },
  },
};
</script>

<style scoped>
.subscription-expired-page {
  background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.subscription-card {
  background: white;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 500px;
  width: 100%;
  text-align: center;
}

.subscription-icon {
  font-size: 4rem;
  color: #dc3545; /* Bootstrap danger color */
  margin-bottom: 1rem;
}

.title {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 1rem;
  color: #343a40;
}

.message {
  font-size: 1.1rem;
  color: #6c757d;
  margin-bottom: 1.5rem;
}

.details {
  text-align: left;
  margin-bottom: 2rem;
}

.details p {
  font-size: 1rem;
  color: #495057;
  margin-bottom: 1rem;
}

.details ul {
  list-style-type: disc;
  padding-left: 1.5rem;
  margin-bottom: 1rem;
}

.details ul li {
  font-size: 0.95rem;
  color: #6c757d;
  margin-bottom: 0.5rem;
}

.details a {
  color: #dc3545;
  text-decoration: none;
  font-weight: bold;
}

.details a:hover {
  text-decoration: underline;
}

.btn-renew {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  border-radius: 25px;
  transition: background-color 0.3s ease;
}

.btn-renew:hover {
  background-color: #c82333;
}
</style>
